"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDynamicCodeResetLoginPwdRequest = void 0;
var GetDynamicCodeResetLoginPwdRequest = /** @class */ (function () {
    function GetDynamicCodeResetLoginPwdRequest() {
    }
    return GetDynamicCodeResetLoginPwdRequest;
}());
exports.GetDynamicCodeResetLoginPwdRequest = GetDynamicCodeResetLoginPwdRequest;
;
//# sourceMappingURL=getDynamicCodeResetLoginPwd.request.js.map